import React from 'react';
import { RouteName } from 'components/dynamic-page/route-matchers';
import { useFeaturesContext } from 'contexts';
import type { TenantNavigationConfig } from '@tenants/types';
import { Logo } from 'components/header/shared';
import MobileSection from './components/MobileSection';
import { DesktopNavigation } from './components/DesktopNavigation';
import { HeaderContent } from './components/HeaderContent';
import { headerIds } from 'constants/test-constants';
import dataJSON from './data.json';
import styles from './style.module.scss';

type ZooHeaderProps = {
  routeName?: RouteName;
  navConfig?: TenantNavigationConfig;
  useLightTheme?: boolean;
};

const ZooHeader = ({ routeName, navConfig, useLightTheme }: ZooHeaderProps) => {
  const { userLinks } = dataJSON;
  const { isSearchPanelOpen } = useFeaturesContext();
  const menuTrigger = navConfig?.menuTrigger;

  return (
    <HeaderContent
      isSearchPanelOpen={isSearchPanelOpen}
      useLightTheme={useLightTheme}
      renderLogo={() => (
        <Logo 
          ariaLabel="Zoocasa header logo"
          logoClassName={styles.logo}
          wrapperClassName={styles['logo-with-caption']}
          testId={headerIds.zoocasaHeaderLogo}
          caption="Zoocasa Realty Inc., Brokerage"
          captionClassName={styles['brokerage-legal-name']}
        />
      )}
      renderDesktop={() => (
        <DesktopNavigation 
          userLinks={userLinks}
          routeName={routeName}
          menuTrigger={menuTrigger}
          userTrigger={navConfig?.mobileUserTrigger}
        />
      )}
      renderMobile={() => (
        <MobileSection 
          userLinks={userLinks}
          routeName={routeName}
          mobileUserTrigger={navConfig?.mobileUserTrigger}
          mobileMenuTrigger={navConfig?.mobileMenuTrigger}
          panelClassName={navConfig?.panelClassName}
        />
      )}
    />
  );
};

export default ZooHeader;
